import { gql } from '@apollo/client';

export const REPORT_SCHEDULE_FRAGMENT = gql`
  fragment reportScheduleFragment on ReportSchedule {
    days
    frequency
    emailNow
  }
`;

export const MIN_MAX_STRING_VALUES_FRAGMENT = gql`
  fragment minMaxStringValuesFragment on MinMaxStringValues {
    min
    max
  }
`;

export const MIN_MAX_NUMBER_VALUES_FRAGMENT = gql`
  fragment minMaxNumberValuesFragment on MinMaxNumberValues {
    min
    max
  }
`;
